/**
 * rowSelection.ts
 *
 * User-facing copy for the shared checkbox-row selection gesture provided by
 * `hooks/useRowRangeSelection.ts` (BUG-2026-0188): tick one row, Shift-click
 * another, and the whole span toggles. Shared by every editable test-data table
 * that offers bulk row selection (rock TCS / UCS readings panels, Direct Shear
 * result-entry grid) so the hint reads identically everywhere.
 */

/** Inline tip shown next to an editable data table. */
export const ROW_RANGE_SELECT_TIP = 'Tip: tick a row, then Shift-click another to select the whole range.';

/** Tooltip on the header "select all" checkbox. */
export const SELECT_ALL_ROWS_TOOLTIP = 'Select all rows (Shift-click a checkbox to select a range)';
